// extracted by mini-css-extract-plugin
export default {"Box":"Projekt_Box__VJpPR","SucheBox":"Projekt_SucheBox__-MTtg","BoxInnerHeader":"Projekt_BoxInnerHeader__cbsql","BoxHeader":"Projekt_BoxHeader__m2B3k"};